export default __webpack_public_path__ + "static/media/icon-chevron-up.ca727295.svg";